<template>
  <ActivityHistoryTable
    :title="text.detail.tabPanels.history.title"
    :subtitle="text.detail.tabPanels.history.subtitle"
    :loading="loading"
    :rows="rows"
    :loading-text="text.detail.history.loading"
    :empty-text="text.detail.history.empty"
    :headers="text.detail.history.table.headers"
    :row-fallback="text.detail.history.fallback"
  />
</template>

<script>
import paymentReceiptsService from '@/services/paymentReceipts';
import { extractCollection } from '@/utils/dataNormalization';
import { formatDateTimeShort } from '@/utils/datePresentation';
import ActivityHistoryTable from '@/components/common/ActivityHistoryTable.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('paymentReceipts');

export default {
  name: 'PaymentReceiptDetailTabHistory',
  components: {
    ActivityHistoryTable,
  },
  props: {
    paymentReceipt: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      text,
      loading: false,
      rows: [],
      requestToken: 0,
    };
  },
  computed: {
    paymentReceiptId() {
      return Number(this.paymentReceipt?.id || 0);
    },
  },
  watch: {
    paymentReceiptId: {
      immediate: true,
      handler() {
        this.loadHistory();
      },
    },
  },
  methods: {
    async loadHistory() {
      const paymentReceiptId = Number(this.paymentReceiptId || 0);
      if (paymentReceiptId <= 0) {
        this.rows = [];
        return;
      }

      this.loading = true;
      const token = this.requestToken + 1;
      this.requestToken = token;

      try {
        const response = await paymentReceiptsService.activity(paymentReceiptId, { per_page: 200 });
        if (token !== this.requestToken) {
          return;
        }

        this.rows = extractCollection(response)
          .map((row) => this.mapHistoryRow(row))
          .filter((row) => row !== null);
      } catch (error) {
        if (token === this.requestToken) {
          this.rows = [];
        }
      } finally {
        if (token === this.requestToken) {
          this.loading = false;
        }
      }
    },
    mapHistoryRow(raw) {
      if (!raw || typeof raw !== 'object') {
        return null;
      }

      return {
        id: Number(raw.id || 0) || `history-${Date.now()}`,
        date_label: formatDateTimeShort(raw.happened_at || raw.created_at || raw.date_label, { fallback: this.text.detail.history.fallback.date }),
        module_label: String(raw.module_label || this.text.detail.history.fallback.module).trim() || this.text.detail.history.fallback.module,
        event_label: String(raw.event_label || this.text.detail.history.fallback.event).trim() || this.text.detail.history.fallback.event,
        description_label: String(raw.description_label || raw.title || this.text.detail.history.fallback.description).trim()
          || this.text.detail.history.fallback.description,
        actor_label: String(raw.actor_label || raw.actor_name || this.text.detail.history.fallback.actor).trim()
          || this.text.detail.history.fallback.actor,
      };
    },
  },
};
</script>
